import React, { useState } from 'react';
import { md, isBlankBlock } from '../utils/markdown';

const BookSection = () => {
  const [selectedCategory, setSelectedCategory] = useState('');
  const [results, setResults] = useState('');

  const BOOK_API_URL = 'https://dca1vgeaea.execute-api.ap-northeast-2.amazonaws.com/book/genai-book-api';

  const categories = [
    { id: '351', name: '컴퓨터/IT' },
    { id: '170', name: '경제경영' },
    { id: '336', name: '자기계발' },
    { id: '987', name: '과학' },
    { id: '656', name: '인문학' },
    { id: '74', name: '역사/문화' },
    { id: '1', name: '소설/시' },
    { id: '55890', name: '건강/취미' },
    { id: '1322', name: '외국어' }
  ];

  // 카테고리를 3개씩 그룹으로 나누는 함수
  const chunkArray = (array, size) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  };

  const categoryGroups = chunkArray(categories, 3);

  const handleCategoryClick = async (categoryId, categoryName) => {
    setSelectedCategory(categoryId);
    setResults(`AI가 '${categoryName}' 분야의 베스트셀러를 추천 중입니다...`);

    try {
      const response = await fetch(BOOK_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ category_id: categoryId, category_name: categoryName })
      });

      if (response.ok) {
        const data = await response.json();
        
        const recommendations = data.ai_recommendations;

        const formattedRecommendations = recommendations
          .split('\n\n')
          .filter(block => !isBlankBlock(block))
          .map((block, index) => {
            const trimmed = block.trim();
            // 첫 블록이 소개글(### 없음)이면 intro 스타일
            if (index === 0 && !trimmed.startsWith('#') && !trimmed.match(/^\d+\./)) {
              return `<div class="book-intro">${md(trimmed)}</div>`;
            }
            return `<div class="book-recommendation">${md(trimmed)}</div>`;
          })
          .join('');

        setResults(`
          <h3>📚 '${categoryName}' 분야 베스트셀러 추천</h3>
          <div class="book-recommendations-content">
            ${formattedRecommendations}
          </div>
        `);
      } else {
        const errorData = await response.json();
        setResults(`에러 발생: ${errorData.message}`);
      }
    } catch (error) {
      console.error('베스트셀러 추천 오류:', error);
      setResults(`서버와 통신 중 오류가 발생했습니다: ${error.message}`);
    }
  };

  return (
    <section className="service-section">
      <h2>도서 추천 AI 서비스</h2>
      <p className="info-text">(알라딘 베스트셀러 기준)</p>
      {categoryGroups.map((categoryGroup, groupIndex) => (
        <div key={groupIndex} className="button-container" style={{ marginTop: groupIndex > 0 ? '15px' : '0' }}>
          {categoryGroup.map(category => (
            <button
              key={category.id}
              className={`category-btn ${selectedCategory === category.id ? 'selected' : ''}`}
              onClick={() => handleCategoryClick(category.id, category.name)}
            >
              {category.name}
            </button>
          ))}
        </div>
      ))}
      {results && <div className="results" dangerouslySetInnerHTML={{ __html: results }}></div>}
    </section>
  );
};

export default BookSection;